import { ReactNode } from 'react';
import { Button } from '../Button';
import * as S from './styles';

export {
  MEDIA_CARD_WIDTH,
  Description as MediaCardDescription,
  Title as MediaCardTitle,
} from './styles';

export type MediaCardProps = {
  'data-testid'?: string;
  infoNode: ReactNode;
  linkHref: string;
  linkLabel: string;
  mediaNode: ReactNode;
};

export const MediaCard = ({
  'data-testid': dataTestId = 'card',
  infoNode,
  linkHref,
  linkLabel,
  mediaNode,
}: MediaCardProps) => {
  return (
    <S.MediaCard data-testid={dataTestId}>
      {mediaNode}

      <S.Info>
        {infoNode}

        <S.ButtonContainer>
          <Button
            analyticsEvent="none"
            buttonSize="small"
            buttonType="secondary"
            disableMinWidth
            fullWidth="never"
            href={linkHref}
          >
            {linkLabel}
          </Button>
        </S.ButtonContainer>
      </S.Info>
    </S.MediaCard>
  );
};
